import DashboardLayout from '../layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../pages/NotFoundPage.vue'

// Admin pages
import Home from 'src/pages/Home.vue'
import Login from 'src/pages/Login.vue'

import Vessel from 'src/pages/datamaster/Vessel.vue'
import ListKapal from 'src/pages/datamaster/ListKapal.vue'
import RekeningBank from 'src/pages/datamaster/RekeningBank.vue'
import MasterHardware from 'src/pages/datamaster/MasterHardware.vue'
import HardwareType from 'src/pages/datamaster/HardwareType.vue'
import Supervisor from 'src/pages/datamaster/Supervisor.vue'
import MapTest from 'src/pages/datamaster/MapTest.vue'
import Pengguna from 'src/pages/datamaster/Pengguna.vue'
import Klien from 'src/pages/datamaster/Klien.vue'
import CreatePopupKlien from 'src/pages/datamaster/CreatePopupKlien.vue'
import CreatePopupVendor from 'src/pages/datamaster/CreatePopupVendor.vue'
import Vendor from 'src/pages/datamaster/Vendor.vue'
import HardwarePrice from 'src/pages/datamaster/HardwarePrice.vue'
import ItemLain from 'src/pages/datamaster/ItemLain.vue'
import AirtimePrice from 'src/pages/datamaster/AirtimePrice.vue'
import Discount from 'src/pages/datamaster/Discount.vue'
import Application from 'src/pages/datamaster/Application.vue'
import Packet from 'src/pages/datamaster/Packet.vue'
import KwitansiType from 'src/pages/datamaster/KwitansiType.vue'
import Location from 'src/pages/datamaster/Location.vue'
import Warehouse from 'src/pages/datamaster/Warehouse.vue'
import Complaint from 'src/pages/datamaster/Complaint.vue'

import UserProfile from 'src/pages/UserProfile.vue'
import TableList from 'src/pages/TableList.vue'
import Typography from 'src/pages/Typography.vue'
import Icons from 'src/pages/Icons.vue'
import Maps from 'src/pages/Maps.vue'
import Notifications from 'src/pages/Notifications.vue'
import Upgrade from 'src/pages/Upgrade.vue'

import Tracking from 'src/pages/Maps/Tracking.vue'

import HardwareQualityControl from 'src/pages/inventaris/HardwareQualityControl.vue'
import HardwareSetup from 'src/pages/inventaris/HardwareSetup.vue'
import WarehouseTransfer from 'src/pages/inventaris/WarehouseTransfer.vue'
import Stock from 'src/pages/inventaris/Stock.vue'

import UnitReport from 'src/pages/laporan/UnitReport'
import AirtimeReport from 'src/pages/laporan/AirtimeReport'
import SalesOrderReport from 'src/pages/laporan/SalesOrderReport'
import OtherReport from 'src/pages/laporan/OtherReport'
import KwitansiReport from 'src/pages/laporan/KwitansiReport'
import ReminderLetter from 'src/pages/laporan/ReminderLetter.vue'
import TroubleshootReport from 'src/pages/laporan/TroubleshootReport.vue'

import PurchaseOrder from 'src/pages/pemesanan/PurchaseOrder.vue'
import Kwitansi from 'src/pages/pemesanan/Kwitansi.vue'
import SalesOrder from 'src/pages/pemesanan/SalesOrder.vue'
import InvoiceItem from 'src/pages/pemesanan/InvoiceItem.vue'
import InvoiceAirtime from 'src/pages/pemesanan/InvoiceAirtime.vue'
import InvoiceLain from 'src/pages/pemesanan/InvoiceLain.vue'


import Troubleshoot from 'src/pages/Troubleshoot.vue'
import RenewalAirtime from 'src/pages/pengingat/RenewalAirtime.vue'

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/admin/home'
  },
  {
    path: '/login',
    component: Login,
  },
  {
    path: '/admin',
    component: DashboardLayout,
    redirect: '/admin/home',
    children: [
      {
        path: 'geoloc/test',
        component: MapTest,
        name:'MapTest'
      },
      {
        path: 'home',
        name: 'Home',
        component: Home
      },
      {
        path: 'datamaster/vessel',
        name: 'Vessel',
        component: Vessel
      },
      {
        path: 'datamaster/list-kapal',
        name: 'List Kapal',
        component: ListKapal
      },
      {
        path: 'datamaster/rekening-bank',
        name: 'Rekening Bank',
        component: RekeningBank
      },
      {
        path: 'datamaster/vendor',
        name: 'Vendor',
        component: Vendor
      },
      {
        path: 'datamaster/klien',
        name: 'Klien',
        component: Klien
      },
      {
        path: 'datamaster/pengguna',
        name: 'Pengguna',
        component: Pengguna
      },
      {
        path: 'datamaster/hardware',
        name: 'MasterHardware',
        component: MasterHardware
      },
      {
        path: 'datamaster/hardwaretype',
        name: 'HardwareType',
        component: HardwareType
      },
      {
        path: 'datamaster/supervisor',
        name: 'Supervisor',
        component: Supervisor
      },
      {
        path: 'datamaster/hardware-price',
        name: 'Hardware Price',
        component: HardwarePrice
      },
      {
        path: 'datamaster/airtime-price',
        name: 'Airtime Price',
        component: AirtimePrice
      },
      {
        path: 'datamaster/item-lain',
        name: 'Secondary Item',
        component: ItemLain
      },
      {
        path: 'datamaster/discount',
        name: 'Discount',
        component: Discount
      },
      {
        path: 'datamaster/application',
        name: 'Application',
        component: Application
      },
      {
        path: 'datamaster/packet',
        name: 'Packet',
        component: Packet
      },
      {
        path: 'datamaster/kwitansi-type',
        name: 'Kwitansi Type',
        component: KwitansiType
      },
      {
        path: 'datamaster/location',
        name: 'Location',
        component: Location
      },
      {
        path: 'datamaster/warehouse',
        name: 'Warehouse',
        component: Warehouse
      },
      {
        path: 'datamaster/Complaint',
        name: 'Complaint',
        component: Complaint
      },
      {
        path: 'user',
        name: 'User',
        component: UserProfile
      },
      {
        path: 'table-list',
        name: 'Table List',
        component: TableList
      },
      {
        path: 'typography',
        name: 'Typography',
        component: Typography
      },
      {
        path: 'icons',
        name: 'Icons',
        component: Icons
      },
      {
        path: 'maps',
        name: 'Maps',
        component: Maps
      },
      {
        path: 'notifications',
        name: 'Notifications',
        component: Notifications
      },
      {
        path: 'upgrade',
        name: 'Upgrade to PRO',
        component: Upgrade
      },
      {
        path: 'inventaris/hardware-qc',
        name: 'Hardware Quality Control',
        component: HardwareQualityControl
      },
      {
        path: 'inventaris/hardware-setup',
        name: 'Hardware Setup',
        component: HardwareSetup
      },
      {
        path: 'inventaris/warehouse',
        name: 'Warehouse Transfer',
        component: WarehouseTransfer
      },
      {
        path: 'inventaris/stock',
        name: 'Stock',
        component: Stock
      },
      {
        path: 'pemesanan/purchase-order',
        name: 'Purchase Order',
        component: PurchaseOrder
      },
      {
        path: 'pemesanan/kwitansi',
        name: 'Kwitansi',
        component: Kwitansi
      },
      {
        path: 'pemesanan/sales-order',
        name: 'Sales Order',
        component: SalesOrder
      },
      {
        path: 'pemesanan/invoice-item',
        name: 'Invoice Item',
        component: InvoiceItem
      },
      {
        path: 'pemesanan/invoice-airtime',
        name: 'Invoice Airtime',
        component: InvoiceAirtime
      },
      {
        path: 'pemesanan/invoice-lain',
        name: 'Invoice Lain',
        component: InvoiceLain
      },
      {
        path: 'pengingat/renewal-airtime',
        name: 'Renewal Airtime',
        component: RenewalAirtime
      },
    ]
  },
  {
    path: '/misc',
    component: DashboardLayout,
    redirect: '/misc/troubleshoot',
    children: [
      {
        path: '/misc/troubleshoot',
        name: 'Troubleshoot',
        component: Troubleshoot
      },
      {
        path: '/misc/reminderletter',
        name: 'Reminder Letter',
        component: ReminderLetter
      },
    ]
  },
  {
    path: '/misc',
    component: DashboardLayout,
    redirect: '/misc/unit-report',
    children: [
      {
        path: '/misc/unit-report',
        name: 'Unit Report',
        component: UnitReport
      },
      {
        path: '/misc/airtime-report',
        name: 'Airtime Report',
        component: AirtimeReport
      },
      {
        path: '/misc/so-report',
        name: 'Sales Order Report',
        component: SalesOrderReport
      },
      {
        path: '/misc/other-report',
        name: 'Other Report',
        component: OtherReport
      },
      {
        path: '/misc/kwitansi-report',
        name: 'Kwitansi Report',
        component: KwitansiReport
      },
      {
        path: '/misc/reminderletter',
        name: 'Reminder Letter',
        component: ReminderLetter
      },
      {
        path: '/misc/troubleshootreport',
        name: 'Troubleshoot Report',
        component: TroubleshootReport
      },
    ]
  },
  {
    path: '/admin/datamaster/create-popup-klien',
    name: 'CreatePopupKlien',
    component: CreatePopupKlien
  },
  {
    path: '/admin/datamaster/create-popup-vendor',
    name: 'CreatePopupVendor',
    component: CreatePopupVendor
  },
  { path: '*', component: NotFound }
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes
